import React, { useState } from 'react';
import {
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Typography,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import Sidebar from './Sidebar';

const drawerWidth = 280;

const DashboardLayout = ({ 
  children, 
  title, 
  user, 
  onLogout, 
  menuItems,
  logoutPath = '/login',
  topHeading,
  ctaButton
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSidebarClose = () => {
    setMobileOpen(false);
  };

  // Sidebar should be open on desktop by default, controlled on mobile
  const sidebarOpen = isMobile ? mobileOpen : true;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
      {/* Mobile menu toggle button - visible only on mobile and sidebar is closed */}
      {isMobile && !sidebarOpen && (
        <Box
          sx={{
            position: 'fixed',
            top: 16,
            left: 16,
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <IconButton
            color="primary"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ 
              backgroundColor: 'white',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              }
            }}
            aria-label="open drawer"
          >
            <MenuIcon />
          </IconButton>
        </Box>
      )}
      
      <Sidebar
        open={sidebarOpen}
        onClose={handleSidebarClose}
        menuItems={menuItems}
        title={title}
        user={user}
        isMobile={isMobile}
        onLogout={onLogout}
      />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { 
            xs: '100%',
            md: `calc(100% - ${drawerWidth}px)` 
          },
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          pt: 0,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {/* Top Header Row with Heading and CTA */}
        {(topHeading || ctaButton) && (
          <Box sx={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: 2,
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 2, sm: 2.5, md: 3 },
            backgroundColor: '#e8ecf1',
            borderBottom: '1px solid #dce0e8',
          }}>
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: 600,
                color: '#1b2a6b',
                fontSize: { xs: '1.1rem', md: '1.5rem' },
                flexShrink: 0,
                whiteSpace: 'nowrap',
              }}
            >
              {topHeading}
            </Typography>
            {ctaButton && (
              <Box sx={{ 
                marginLeft: 'auto',
                flexShrink: 0,
              }}>
                {ctaButton}
              </Box>
            )}
          </Box>
        )}

        <Box sx={{ 
          p: { 
            xs: 2, 
            sm: 3,
            md: 4 
          },
          width: '100%',
          maxWidth: '100%',
          overflow: 'auto'
        }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;

